var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.8955 0H1.10387C0.494632 0 0 0.493644 0 1.10387V18.8955C0 19.5057 0.494632 20 1.10387 20H10.6823V12.2548H8.07614V9.23599H10.6823V7.00981C10.6823 4.42699 12.2594 3.01982 14.564 3.01982C15.6688 3.01982 16.6163 3.10248 16.8926 3.13838V5.83811L15.2941 5.83877C14.041 5.83877 13.7993 6.4345 13.7993 7.30817V9.235H16.7888L16.3979 12.2535H13.799V19.999H18.8951C19.505 19.999 20 19.5041 20 18.8955V1.10321C19.9997 0.493644 19.5054 0 18.8955 0Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
